import {useMemo} from 'react';

const parsePrice = (value) => {
  if (value == null || typeof value !== 'string') return NaN;
  const num = parseFloat(value.replace(/[$,]/g, ''), 10);
  return Number.isFinite(num) ? num : NaN;
};

/**
 * Computes the minimum yearly discount percent across all plan pairs.
 * Returns null if no comparable monthly/yearly plan pairs exist.
 */
const useYearlyDiscountPercent = sortedPlans =>
  useMemo(() => {
    if (!sortedPlans.length) return null;

    const byAccessLevel = {};
    sortedPlans.forEach((plan) => {
      const cycle = plan.billing_cycle;
      if (cycle !== 'monthly' && cycle !== 'yearly') return;
      const key = plan.access_level || plan.planKey;
      if (!byAccessLevel[key]) byAccessLevel[key] = {};
      byAccessLevel[key][cycle] = plan;
    });

    const discounts = [];
    Object.values(byAccessLevel).forEach((pair) => {
      const {monthly, yearly} = pair;
      if (!monthly || !yearly) return;
      const monthlyPrice = parsePrice(monthly.price);
      const yearlyPrice = parsePrice(yearly.price);
      if (Number.isFinite(monthlyPrice) && Number.isFinite(yearlyPrice) && monthlyPrice > 0) {
        const discount = Math.round((1 - yearlyPrice / monthlyPrice) * 100);
        if (discount > 0) discounts.push(discount);
      }
    });

    return discounts.length === 0 ? null : Math.min(...discounts);
  }, [sortedPlans]);

export default useYearlyDiscountPercent;
